import moment from 'moment';

export let DateUtility = {
    fpDateToMoment: function (inputDate) {
        if (inputDate) {
            return moment(inputDate, 'YYYY-MM-DDTHH:mm:ss.SSS');
        } else {
            return null;
        }
    },

    momentToLocalMoment: function (momentIn) {
        return momentIn.local();
    },

    momentToDisplayDate: function (momentIn) {
        return momentIn.format('MM/DD/YYYY');
    },

    fpDateToLocalTextDate: function (inputDate) {
        if (inputDate) {
            return DateUtility.momentToDisplayDate(DateUtility.fpDateToMoment(inputDate));
        } else {
            return null;
        }
    },

    stripeTimestampToDateDisplay: function (stripeTimestamp) {
        return DateUtility.momentToDisplayDate(
            DateUtility.stripeTimestampToMoment(stripeTimestamp)
        )
    },

    stripeTimestampToMoment: function (stripeTimestamp) {
        return moment.unix(stripeTimestamp)
    },

    dbDateToTimestamp: function (inputDate) {
        return DateUtility.dbDateToMoment(inputDate)?.unix()
    },

    dbDateToMoment: function (inputDate) {
        if (inputDate) {
            return moment.utc(inputDate.replace('Z', ''), 'YYYY-MM-DDTHH:mm:ss.SSS');
        } else {
            return null;
        }
    },

    dbDateToLocalMoment: function (inputDate) {
        if (inputDate) {
            return this.dbDateToMoment(inputDate).local();
        } else {
            return null;
        }
    },

    dbDateToLocalDisplayDate: function (inputDate) {
        if (inputDate) {
            return DateUtility.momentToDisplayDate(DateUtility.dbDateToLocalMoment(inputDate))
        } else {
            return null;
        }
    },

    currentJsDate: function () {
        return moment().toDate()
    },

    jsDateToUnixTimestamp: function (jsDate) {
        return moment(jsDate).unix()
    }
}
